<template>
  <div class="flex flex-col lg:flex-row gap-5 lg:gap-9">
    <RelatedCategories
      v-for="tree in relatedTrees"
      :key="tree.title"
      :title="tree.title"
      :related-categories="tree.categories"
      class="w-full lg:w-1/2"
    />
  </div>
</template>

<script lang="ts">

import type { RelatedTree } from '~~/types/category/RelatedCategory';

export default defineComponent({
  name: 'RelatedCategoryTrees',

  props: {
    relatedTrees: {
      type: Array as PropType<RelatedTree[]>,
      default: () => [],
    },
  },
});

</script>
